import React from "react";
import { connect } from "react-redux";

import DocumentCreator from "../Creator";
import DocumentExport from "../Export";

class Document extends React.Component {
  get id() {
    return this.props.match.params.id ?? null;
  }

  get type() {
    return this.props.match.params.type ?? null;
  }

  get title() {
    switch (this.type) {
      case "purchase":
        return "Purchase Order";
      default:
    }

    return null;
  }

  get total() {
    switch (this.type) {
      case "purchase":
        return "0.00";
      default:
    }

    return "0.00";
  }

  get reference() {
    switch (this.type) {
      case "purchase":
        return "";
      default:
    }

    return null;
  }

  get date() {
    switch (this.type) {
      case "purchase":
        return "";
      default:
    }

    return null;
  }

  get items() {
    switch (this.type) {
      case "purchase":
        return [
          {
            quantity: 0,
            description: "description",
            partnumber: "sku",
            price: "0.00",
            subtotal: "0.00",
          },
        ];
      default:
    }

    return [];
  }

  get addressTo() {
    switch (this.type) {
      case "purchase":
        return ["address", "address", "address", "address", "address"];
      default:
    }

    return [];
  }

  get addressFrom() {
    switch (this.type) {
      case "purchase":
        return ["address", "address", "address", "address", "address"];
      default:
    }

    return [];
  }

  render() {
    const {
      id,
      date,
      reference,
      type,
      title,
      addressTo,
      addressFrom,
      items,
      total,
    } = this;

    const document = {
      id,
      date,
      reference,
      title,
      type,
      addressTo,
      addressFrom,
      items,
      total,
    };

    return (
      <React.Fragment>
        <DocumentExport document={document} />
        <DocumentCreator document={document} />
      </React.Fragment>
    );
  }
}

export default connect((state) => {
  return {};
}, {})(Document);
